import { render, staticRenderFns } from "./pesanangratisfrm.vue?vue&type=template&id=e67df27e"
import script from "./pesanangratisfrm.vue?vue&type=script&lang=js"
export * from "./pesanangratisfrm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports